const inicialState = {
  histologiaFinalizada: false,  
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/histo/histo.state.js